export const createPost = (post) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => { // know what to connect to because of the config passed in index js file
        const firestore = getFirestore();
        const profile = getState().firebase.profile;
        const authorId = getState().firebase.auth.uid; 
        firestore.collection("posts").add({
            ...post,
            authorFirstName: profile.firstName,
            authorLastName: profile.lastName,
            authorId: authorId,
            dateCreated: new Date(),
        }).then(() => {
            dispatch({ type: 'CREATE_POST', post});
        }).catch((error) => {
            dispatch({ type: 'CREATE_POST_ERROR', error});
        })
        
    }
};

export const updatePost = (post) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => { // know what to connect to because of the config passed in index js file
        const firestore = getFirestore();
        firestore.collection("posts")
        .get()
        .then((documents) => {
            documents.forEach((doc) => {
                if(doc.id === post.id) {
                    firestore.collection("posts").doc(doc.id).update({
                        title: post.title,
                        content: post.content,
                        activated: post.activated
                    });
                }
            });
        }).then(() => {
            dispatch({ type: 'UPDATE_POST', post});
        }).catch((error) => {
            dispatch({ type: 'UPDATE_POST_ERROR', error});
        })
    }
}

export const deletePost = (id) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => { // know what to connect to because of the config passed in index js file
        const firestore = getFirestore();
        firestore.collection("posts")
        .get()
        .then((documents) => {
            documents.forEach((doc) => {
                if(doc.id === id) {
                    firestore.collection("posts").doc(doc.id).delete().then(() => {
                        dispatch({ type: 'DELETE_POST', id});
                    }).catch((error) => {
                        dispatch({ type: 'DELETE_POST_ERROR', error});
                    });
                }
            });
        });
    } 
}